import script from "./VUserInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./VUserInfo.vue?vue&type=script&lang=ts&setup=true"

import "./VUserInfo.vue?vue&type=style&index=0&id=45cbf09d&lang=sass"

const __exports__ = script;

export default __exports__